module.exports = __webpack_public_path__ + "static/img/indexbg6.1ae1832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg6.jpg
// module id = c4Gq
// module chunks = 1